export enum TypeFeedbackEnum {
    Sugestao = 1,
    Critica = 2,
    Elogio = 3,
}